<app-pigeonhole-map-tooltip
  #tooltipElement
  [ngStyle]="getTooltipPosition()"
  [ngClass]="{ show: showTooltip, hide: !showTooltip }"
  [content]="tooltipValues"
  (dimensionsChange)="onTooltipDimensionsChange($event)"
  >
</app-pigeonhole-map-tooltip>

<div class="map-legend" [ngClass]="{'expand': toggleTip}" (click)="onToggleTip()" *ngIf="!isMapEmpty">
  <i class="uil uil-minus" *ngIf="!toggleTip"></i>
  <ng-container *ngIf="toggleTip">
    <div class="legend title">Para navegar pelo mapa utilize o mouse:</div>
    <div class="legend item"><img src="assets/icons/zoom-in.svg"> Zoom: scroll do mouse</div>
    <div class="legend item"><img src="assets/icons/drag.svg"> Navegar: clique e arraste</div>
  </ng-container>
</div>

<div class="empty-map" *ngIf="isMapEmpty">
  NÃO EXISTE TAGS CADASTRADAS NO SISTEMA.
</div>
